import React from 'react'
import { Collapse, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ActionButton } from '@emerald-works-nova/components'
import { useDispatch, useSelector } from 'react-redux'
import { UserUploadSlice } from '../../../../reducers'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    marginBottom: spacing(2),
    paddingBlock: spacing(3),
    paddingInline: spacing(4),
    background: palette.grey.lighter,
    border: `1px dashed ${palette.grey.dark}`,
    borderRadius: 4
  }
}))

const UserUploadResults = () => {
  const classes = useStyles()
  const result = useSelector(UserUploadSlice.selectors.selectResult)
  const dispatch = useDispatch()

  const handleDismiss = () => {
    dispatch(UserUploadSlice.actions.reset())
  }

  return (
    <Collapse in={!!result}>
      {result && (
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          className={classes.root}
        >
          <Grid item xs>
            <Typography variant='caption'>
              <strong>
                {new Date(result.date).toLocaleDateString()} - Bulk Upload of
                Users Log
              </strong>
              <br />
              Total number of records on file: {result.total}
              <br />
              Failed records: {result.errors}
              <br />
              Total users uploaded: {result.total - result.errors}
            </Typography>
          </Grid>
          <Grid
            item
            xs={3}
            container
            direction='column'
            alignItems='flex-end'
            spacing={2}
          >
            <Grid item>
              <ActionButton text='Dismiss' noBorder onClick={handleDismiss} />
            </Grid>
            <Grid item>
              <ActionButton
                text='Download CSV File'
                component='a'
                href={result.url}
                target='_blank'
                disabled={!result.url}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Collapse>
  )
}

export default UserUploadResults
